"use client";

import React, { useState } from "react";
import DentalHero from "@/components/demos/dental/DentalHero";
import DentalServicesSection from "@/components/demos/dental/DentalServicesSection";
import ClinicalFacultySection from "@/components/demos/dental/ClinicalFacultySection";
import ConsultationModal from "@/components/demos/dental/ConsultationModal";
import { DemoCommercialBanner } from "@/components/demos/DemoCommercialBanner";
import { DentalTreatment } from "@/lib/demos/dentalData";

interface DentalPageProps {
  currency?: "INR" | "USD";
}

export default function DentalPage({ currency = "INR" }: DentalPageProps) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedTreatment, setSelectedTreatment] = useState<string | undefined>(undefined);

  const handleOpenBooking = (treatmentName?: string) => {
    setSelectedTreatment(treatmentName);
    setIsModalOpen(true);
  };

  const handleSelectTreatment = (treatment: DentalTreatment) => {
    setSelectedTreatment(treatment.name);
    setIsModalOpen(true);
  };

  const handleScrollToTreatments = () => {
    const el = document.getElementById("specialty-treatments");
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div>
      <DentalHero
        onOpenBooking={() => handleOpenBooking()}
        onExploreTreatments={handleScrollToTreatments}
        currency={currency}
      />

      <DemoCommercialBanner
        title="Deploy This Custom Clinical EMR & Practice Management Software"
        description="DPDP Act 2023 compliant patient charting, doctor OPD queues, digital prescription dispatch, and automated WhatsApp appointment reminders with zero per-doctor monthly fees."
        targetUrl="/healthcare-software"
        targetLabel="Explore Healthcare Software & Pricing"
        secondaryUrl="/demos/dental/crm"
        secondaryLabel="Open Doctor Clinic CRM"
        accent="rose"
      />

      <DentalServicesSection
        currency={currency}
        onSelectTreatment={handleSelectTreatment}
      />

      <ClinicalFacultySection
        onOpenBooking={() => handleOpenBooking()}
      />

      {/* Consultation Intake Modal */}
      <ConsultationModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        currency={currency}
        preselectedTreatment={selectedTreatment}
      />
    </div>
  );
}
